var isWiderScreen = window.outerWidth > 500;
var supportsPassive = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function() {
      supportsPassive = true;
    }
  });
  window.addEventListener("testPassive", null, opts);
  window.removeEventListener("testPassive", null, opts);
} catch (e) {}

reloadIfInstagramToFixHeight();
loadIntroImage();

function loadIntroImage() {
  setVh();
  var image = document.querySelector('.intro img');
  if (!image)
    return;
  var params = getResizerParams(document.body);
  var src = image.getAttribute('data-src');
  if (!src)
    return;
  image.setAttribute('src', appendResizerParams(src, params));
}

function reloadIfInstagramToFixHeight() {
  var ua = navigator.userAgent || navigator.vendor || window.opera;
  var isInstagram = (ua.indexOf('Instagram') > -1) ? true : false;
  if (isInstagram) {
    var isReloading = window.localStorage.getItem('isReloading');
    if (isReloading) {
      window.localStorage.removeItem('isReloading');
      return;
    }
    window.localStorage.setItem('isReloading', 'true');
    window.location.reload();
  }
}

function setVh() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
} 

function getResizerParams(element, smallestHeight) {
  var width = bucketSize(element.clientWidth, [320, 414, 480, 640, 820]);
  var dpr = window.devicePixelRatio >= 1.5 ? 2 : 1;
  var maxHeight = smallestHeight ? '&fit=crop&h=' + bucketSize(smallestHeight, [308, 400, 615, 800]) : '';
  return 'w=' + width + '&dpr=' + dpr + '&fm=webp&q=88' + maxHeight;
}

function bucketSize(value, buckets) {
  for (var i = 0; i < buckets.length; i++) {
    if (value <= buckets[i])
      return buckets[i];
  }
  return buckets[buckets.length - 1];
}

function appendResizerParams(src, params) {
  if (!params)
    return src;
  var lastChar = src.charAt(src.length - 1);
  if (lastChar === '?' || lastChar === '&')
    return src + params;
  return src + (src.indexOf('?') === -1 ? '?' : '&') + params;
}

function start(){
  window.addEventListener('scroll', handleScroll);
  var currentStories = document.getElementsByClassName("stories")[0];
  var p = localStorage.getItem('p');
  var overlayTrigger = null;

  document.addEventListener('keydown', handleOverlayKeydown);

  var observer = new IntersectionObserver(checkViewport, {
    rootMargin: '0px 0px 900px 0px',
    threshold: 0
  });

  function startScroll() { 
    ease({
      startValue: 0,
      endValue: window.innerHeight,
      onStep: value => window.scroll(0, value),
    });
  }

  function scrollToCustomerResults(event) {
    var control = event && event.currentTarget;
    var targetSelector = control && control.getAttribute('href');
    var target = targetSelector && targetSelector.charAt(0) === '#'
      ? document.querySelector(targetSelector)
      : document.querySelector('.stories article');
    if (!target)
      return;

    if (event)
      event.preventDefault();

    var startPosition = window.pageYOffset || document.documentElement.scrollTop;
    var targetPosition = target.getBoundingClientRect().top + startPosition - 24;
    ease({
      startValue: startPosition,
      endValue: targetPosition,
      onStep: value => window.scroll(0, value),
    });
  }
  
  var scrollControls = document.querySelectorAll('.arrow');
  scrollControls.forEach(function (control) {
    control.addEventListener('click', startScroll);
  });

  var customerResultControls = document.querySelectorAll('.hero-scroll');
  customerResultControls.forEach(function (control) {
    control.addEventListener('click', scrollToCustomerResults);
  });

  var chatTriggers = document.querySelectorAll('.chat-trigger');
  chatTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', openChat);
  });

  function openChat(event) {
    event.preventDefault();
    var attempts = 0;

    function tryOpenChat() {
      if (window.BriefWidget && typeof window.BriefWidget.open === 'function') {
        window.BriefWidget.open();
        if (window.peachAnalytics)
          window.peachAnalytics.track('chat_open', {
            placement: trigger.closest('.intro') ? 'hero' : trigger.closest('.contact-menu') ? 'contact_menu' : 'contact_card',
            source_page: window.location.pathname
          });
        return;
      }

      attempts++;
      if (attempts < 40)
        window.setTimeout(tryOpenChat, 100);
    }

    tryOpenChat();
  }

  var searchInput = document.querySelector('.search input');
  var debounced = debounce(handleSearchChange, 450);
  if (searchInput) {
    var searchButton = document.querySelector('.search div');
    searchInput.addEventListener('input', debounced);
    searchButton.addEventListener('click', handleSearchClick);
  }

  var navBtns = document.querySelectorAll('nav em');
  navBtns.forEach(function (btn) {
    btn.addEventListener('mousedown', function (e) { btn.classList.add('tap'); }, supportsPassive ? { passive: true } : false);
    btn.addEventListener('mouseup', function (e) { btn.classList.remove('tap'); }, supportsPassive ? { passive: true } : false);
    btn.addEventListener('touchstart', function (e) { btn.classList.add('tap'); }, supportsPassive ? { passive: true } : false);
    btn.addEventListener('touchend', function (e) { btn.classList.remove('tap'); }, supportsPassive ? { passive: true } : false);
  });

  showPendingStory();
  observeStories(document);
  showDelete();

  function showPendingStory() {
    if (!currentStories)
      return;

    var pendingJson = localStorage.getItem('pendingStory');
    if (!pendingJson)
      return;

    var story;
    try {
      story = JSON.parse(pendingJson);
    } catch (e) {
      localStorage.removeItem('pendingStory');
      return;
    }

    if (!story || !story.id) {
      localStorage.removeItem('pendingStory');
      return;
    }

    if (currentStories.querySelector('[data-pending-story-id="' + cssEscape(story.id) + '"], a[href^="/' + cssEscape(story.id) + '"]')) {
      localStorage.removeItem('pendingStory');
      return;
    }

    currentStories.insertAdjacentHTML('afterbegin', getPendingStoryHtml(story));
  }

  function getPendingStoryHtml(story) {
    var title = escapeHtml(story.title || '');
    var route = story.route || '/' + story.id + '/' + toSeoText(story.title || '');
    var media = getPendingMediaHtml(story.images || [], title);
    var date = formatDate(story.date);
    return '<article data-pending-story-id="' + escapeHtml(story.id) + '">' +
      '<h3><a href="' + escapeHtml(route) + '" title="' + title + '">' + title + '</a></h3>' +
      media +
      '<div class="text">' + (story.text || '') + '</div>' +
      '<div class="meta"><span>' + escapeHtml(story.author || '') + '</span><span>Stockholm</span><span>' + date + '</span></div>' +
      '<div class="divider"><em></em><em></em><em></em></div>' +
      '</article>';
  }

  function getPendingMediaHtml(images, title) {
    if (!images.length)
      return '';

    var imageHtml = images.map(function (image) {
      var ratio = image.height && image.width ? (image.height / image.width) * 100 : 120;
      var style = image.height > image.width ? 'max-width:' + Math.max(400, 800 / (image.height / image.width)) + 'px' : '';
      if (image.isVideo) {
        return '<div class="image" style="' + style + '"><div class="image-wrap" style="padding-bottom:' + ratio + '%"><video src="' + escapeHtml(image.src) + '" title="' + title + '" autoplay loop muted playsinline></video></div></div>';
      }

      var altText = escapeHtml(image.altText || title);
      return '<div class="image" style="' + style + '"><div class="image-wrap" style="padding-bottom:' + ratio + '%"><img src="' + escapeHtml(image.src) + '" alt="' + altText + '" /></div></div>';
    }).join('');

    return '<div class="images">' + imageHtml + '</div>';
  }

  function formatDate(value) {
    var date = value ? new Date(value) : new Date();
    if (isNaN(date.getTime()))
      date = new Date();

    return date.toISOString().slice(0, 10);
  }

  function toSeoText(text) {
    return (text || '')
      .toLowerCase()
      .replace(/\&+/g, 'och')
      .replace(/å/g, 'a')
      .replace(/ä/g, 'a')
      .replace(/ö/g, 'o')
      .replace(/'/g, '')
      .replace(/[^a-z0-9]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function cssEscape(value) {
    if (window.CSS && window.CSS.escape)
      return window.CSS.escape(value);

    return String(value || '').replace(/"/g, '\\"');
  }

  function showDelete() {
    if (!p || !currentStories)
      return;
    
    var id = localStorage.getItem('lastId');
    if (!id)
      return;

    var article = findStoryArticle(id);
    if (!article)
      return;
    
    var div = document.createElement('div');
    var aTag = document.createElement('div');
    aTag.innerText = 'Ta bort';
    aTag.classList.add('btn');
    aTag.addEventListener('click', function () { deleteStory(id, article) });
    div.appendChild(aTag);
    div.classList.add('remove');
    var meta = article.querySelector('.meta');
    meta.parentNode.insertBefore(div, meta.nextSibling)
    localStorage.removeItem('lastId');
    scrollToPublishedStory(article);
  }

  function findStoryArticle(id) {
    var pendingArticle = currentStories.querySelector('[data-pending-story-id="' + cssEscape(id) + '"]');
    if (pendingArticle)
      return pendingArticle;

    var storyLinks = currentStories.querySelectorAll('article h3 a[href]');
    for (var i = 0; i < storyLinks.length; i++) {
      try {
        var pathParts = new URL(storyLinks[i].href, window.location.origin).pathname.split('/');
        if (pathParts.length > 1 && pathParts[1] === String(id))
          return storyLinks[i].closest('article');
      } catch (e) {}
    }

    return null;
  }

  function scrollToPublishedStory(article) {
    function scroll() {
      var top = article.getBoundingClientRect().top + window.pageYOffset - 24;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    function scrollWhenLayoutIsReady() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(scroll);
      });
    }

    if (document.readyState === 'complete')
      scrollWhenLayoutIsReady();
    else
      window.addEventListener('load', scrollWhenLayoutIsReady, { once: true });
  }

  function deleteStory(id, article) {
    var shouldSend = confirm('Är du säker?');
    if (!shouldSend)
        return;

    var cmsApiBaseUrl = localStorage.getItem('cmsApiBaseUrl');
    var url = cmsApiBaseUrl ? cmsApiBaseUrl + '/api/cms/stories/' + encodeURIComponent(id) : '/admin?handler=delete&password=' + p + '&id=' + id;
    var headers = cmsApiBaseUrl ? { 'x-peach-admin-token': p } : {};
    fetch(url,
      {
        method: cmsApiBaseUrl ? 'DELETE' : 'POST',
        headers: headers
      })
      .then(function (response) {
        if (!response.ok)
          throw new Error('Kunde inte ta bort inlägget.');

        removePendingStory(id);
        if (article) {
          article.remove();
          return;
        }

        window.location.reload(false);
      })
      .catch(function (error) {
        alert(error.message || error);
      });
  }

  function removePendingStory(id) {
    var pendingJson = localStorage.getItem('pendingStory');
    if (!pendingJson)
      return;

    try {
      var pendingStory = JSON.parse(pendingJson);
      if (pendingStory && pendingStory.id === id)
        localStorage.removeItem('pendingStory');
    } catch (e) {
      localStorage.removeItem('pendingStory');
    }
  }

  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function handleSearchChange(e) {
    var query = e.target.value;
    if (query && window.peachAnalytics)
      window.peachAnalytics.track('search', { search_term: query.slice(0, 100) });
    resetStories();
    load(query, () => {
      var intro = document.querySelector('.intro');
      window.scroll(0, intro.clientHeight);
    });
  }

  function handleSearchClick(e) {
    if (!searchButton.parentElement.classList.contains('open')){
      searchInput.value = '';
      searchButton.parentElement.classList.add('open');
      searchInput.focus();
      searchInput.select();
    }
    else {
      searchButton.parentElement.classList.remove('open');
      searchInput.blur();
      if (searchInput.value) {
        searchInput.value = '';
        resetStories();
        load();
      }
    }
  }

  function resetStories() {
    page = 1;
    currentStories.innerHTML = '';
    setNoMore(false);
  }

  let firstTime = false;
  function checkViewport(entries, self) {
    entries.forEach(entry => {
        if (!entry.isIntersecting)
            return;
        loadMedia(entry.target);
        self.unobserve(entry.target);
    });
    firstTime = true;
  }

  function observeStories(container) {
    var stories = container.querySelectorAll('article:not(.observed)');
    stories.forEach(function (story) {
        observer.observe(story);
        initSwiper(story);
        story.classList.add('observed');
    });
  }

  function initSwiper(story) {
    var mediaContainer = story.querySelector('.images');
    if (!mediaContainer)
      return;
    var images = mediaContainer.querySelectorAll('img, video');
    if (images && images.length > 1)
        new Siema({ selector: mediaContainer, duration: 400 });
  }

  let deferred = [];
  var isBlogSingle = document.body.classList.contains('blog-single');
  function loadMedia(story) {
    var mediaElements = story.querySelectorAll('img, video, iframe');
    var elementsArray = Array.from(mediaElements);
    var onlyImages = elementsArray.filter(function (i) { return i.nodeName === 'IMG' });
    var smallestHeight = onlyImages.length ? onlyImages.sort(function(a, b){return (a.parentElement.clientHeight/a.parentElement.clientWidth) - (b.parentElement.clientHeight/b.parentElement.clientWidth)})[0].parentElement.clientHeight : 0;
    for (let i = 0; i < mediaElements.length; i++) {
      var element = mediaElements[i];
      var src = element.tagName === 'IFRAME' ? element.getAttribute('src') : element.getAttribute('data-src');
      if (!src)
          continue;

      if (element.tagName === 'IFRAME' && src.indexOf('youtube') !== -1) {
        var id = youTubeGetID(src);
        var srcdoc = element.getAttribute('srcdoc');
        var newDoc = srcdoc.replace("src='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'", "src='https://img.youtube.com/vi/" + id + "/maxresdefault.jpg'");
        element.setAttribute('srcdoc', newDoc);
        continue;
      }

      var extension = src.split('?').shift().split('.').pop();
      var isImage = extension.toLowerCase() === 'jpg' 
          || extension.toLowerCase() === 'jpeg'
          || extension.toLowerCase() === 'png';
      
      var params = '';
      if (isImage) {
        if (isWiderScreen && smallestHeight) {
          var newPadding = (smallestHeight/element.width) * 100;
          element.parentElement.style.paddingBottom = newPadding + '%';
        }
        params = getResizerParams(element, smallestHeight);
      }

      if (i > 0 && firstTime === false && !isBlogSingle) {
        deferred.push({ el: element, src: appendResizerParams(src, params) });
      } else {
        setSrc(element, appendResizerParams(src, params));
      }
    }
  }

  function youTubeGetID(url){
    url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
 }

  function initDeferred() {
    if (deferred.length > 0) {
      setTimeout(() => {
        deferred.forEach((d) => {
          setSrc(d.el, d.src);
        });
        deferred = [];
      }, 500);
    }
  }
  
  function setSrc(el, src) {
    el.setAttribute('src', src);
  }

  var isBooking = document.body.classList.contains('booking');
  function handleScroll() {
    var downLimit = window.scrollY > 60;
    if (downLimit) {
      if (!isBlogSingle && !isBooking)
        hideIntro();
      initDeferred();
    }
    else {
      showIntro();
    }

    var reachedPageEnd = window.innerHeight + window.scrollY > document.body.offsetHeight - 1500;
    if (currentStories && reachedPageEnd)
        load(searchInput ? searchInput.value : '');
  }

  function hideIntro() {
    document.body.classList.add("hide");
  }

  function showIntro() {
    document.body.classList.remove("hide");
  }

  var page = 2;
  function load(query, callback) {
    if (loading || noMore)
        return;

    setLoading(true);
    var queryParam = query ? '?query=' + encodeURIComponent(query) : '';
    fetch('/sida/' + page + '/' + queryParam)
      .then(handleResponse)
      .then(handleStories)
      .catch(() => { finalize(); if (callback) callback(); })
      .finally(() => { finalize(); if (callback) callback(); });
  }

  var loading = false;
  function setLoading(value) {
    setMoreButton(!value);
    setLoader(value);
    loading = value;
  }

  var noMore = false;
  function setNoMore(value) {
    setMoreButton(!value);
    noMore = value;
  }

  function setMoreButton(value) {
    var more = document.querySelector(".btn.more");
    if (!more || loading)
      return;
    
    if (value)
      more.style.display = '';
    else
      more.style.display = 'none';
  }

  function setLoader(value) {
    var loader = document.querySelector(".loader");
    if (!loader)
      return;
    
    if (value)
      loader.style.display = '';
    else
      loader.style.display = 'none';
  }

  function handleResponse(response) {
    return response.text();
  }

  function handleStories(htmlString) {
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    var newStories = tempDiv.getElementsByClassName('stories')[0].innerHTML.trim();
    if (newStories.length <= 1) {
      setNoMore(true);
      return;
    }
    currentStories.insertAdjacentHTML('beforeend', newStories);
    observeStories(currentStories);
    page += 1;
  }

  function finalize() {
    setLoading(false);
  }

  var adminButton = document.querySelector(".divider.start");
  if (adminButton) {
    adminButton.addEventListener('click', function () {
        appendOverlay();
        showOverlay();
        loadOverlay('/login');
    });
  }

  var telButton = document.querySelector(".btn.tel");
  if (telButton) {
    telButton.addEventListener('click', function () {
        appendOverlay();
        showOverlay();
        loadOverlay('/call');
    });
  }

  function appendOverlay() {
    var overlay = getOverlay();
    if (overlay)
        return;
    var newOverlay = document.createElement('div');
    newOverlay.id = 'overlay';
    newOverlay.setAttribute('role', 'dialog');
    newOverlay.setAttribute('aria-modal', 'true');
    newOverlay.setAttribute('aria-hidden', 'true');
    newOverlay.setAttribute('tabindex', '-1');
    document.body.appendChild(newOverlay);
  }

  function getOverlay() {
    return document.getElementById('overlay');
  }

  window.showOverlay = function () {
    if (!document.body.classList.contains('show-overlay'))
      overlayTrigger = document.activeElement;
    document.body.classList.remove('hide-overlay');
    document.body.classList.add('show-overlay');
    getOverlay().setAttribute('aria-hidden', 'false');
    setPageInert(true);
    focusOverlay();
  }

  window.hideOverlay = function () {
    document.body.classList.remove('show-overlay');
    document.body.classList.add('hide-overlay');
    getOverlay().setAttribute('aria-hidden', 'true');
    setPageInert(false);
    if (overlayTrigger && document.contains(overlayTrigger))
      overlayTrigger.focus();
    overlayTrigger = null;
  }

  function setPageInert(isInert) {
    var overlay = getOverlay();
    for (var child of document.body.children) {
      if (child !== overlay)
        child.inert = isInert;
    }
  }

  function getOverlayFocusables() {
    var overlay = getOverlay();
    var selector = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
    return Array.from(overlay.querySelectorAll(selector)).filter(function (element) {
      return !element.disabled && element.getAttribute('aria-hidden') !== 'true'
        && (element.offsetWidth > 0 || element.offsetHeight > 0);
    });
  }

  function focusOverlay() {
    var overlay = getOverlay();
    var focusables = getOverlayFocusables();
    (focusables[0] || overlay).focus();
  }

  function handleOverlayKeydown(event) {
    if (!document.body.classList.contains('show-overlay'))
      return;

    if (event.key === 'Escape') {
      event.preventDefault();
      hideOverlay();
      return;
    }

    if (event.key !== 'Tab')
      return;

    var overlay = getOverlay();
    var focusables = getOverlayFocusables();
    if (focusables.length === 0) {
      event.preventDefault();
      overlay.focus();
      return;
    }

    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && (document.activeElement === first || !overlay.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !overlay.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  }

  window.loadContent = function (url, props) {
    var params = p && url.indexOf('?') === -1 ? '?password=' + p : '';
    fetch(url + params, props)
        .then(handleResponse)
        .then(handleContent)
        .catch(finalize)
        .finally(finalize);
  }

  function loadOverlay(url) {
    if (loading)
        return;

    if (isOverlayLoaded())
        return;

    var labels = {
      '/admin': 'Administration',
      '/call': 'Kontakta Peach Stockholm',
      '/login': 'Logga in'
    };
    getOverlay().setAttribute('aria-label', labels[url] || 'Dialogruta');
    setLoading(true);
    loadContent(url);
  }

  function isOverlayLoaded() {
    var overlay = getOverlay();
    return overlay.children.length > 0;
  }

  function handleResponse(response) {
    return response.text();
  }

  function handleContent(htmlString) {
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    if (tempDiv.innerHTML.length <= 1)
        return;
    var overlay = getOverlay();
    overlay.innerHTML = "";
    overlay.insertAdjacentHTML('beforeend', tempDiv.innerHTML);
    if (overlay.querySelector('.admin'))
      overlay.setAttribute('aria-label', 'Administration');
    else if (overlay.querySelector('.call'))
      overlay.setAttribute('aria-label', 'Kontakta Peach Stockholm');
    else if (overlay.querySelector('.login'))
      overlay.setAttribute('aria-label', 'Logga in');
    initScripts();
    if (document.body.classList.contains('show-overlay'))
      focusOverlay();
  }

  function initScripts() {
    var scriptTags = document.querySelectorAll('.script');
    for (var scriptTag of scriptTags) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = scriptTag.dataset.src;
        document.body.appendChild(script);
    }
  }

  function ease({
    startValue = 0,
    endValue = 1,
    durationMs = 700,
    onStep,
    onComplete = () => {},
  }) {
    const raf = window.requestAnimationFrame || (func => window.setTimeout(func, 16));
    
    const stepCount = durationMs / 16;
    const valueIncrement = (endValue - startValue) / stepCount;
    const sinValueIncrement = Math.PI / stepCount;
    
    let currentValue = startValue;
    let currentSinValue = 0;
    
    function step() {
      currentSinValue += sinValueIncrement;
      currentValue += valueIncrement * (Math.sin(currentSinValue) ** 2) * 2;
      
      if (currentSinValue < Math.PI) {
        onStep(currentValue);
        raf(step);
      } else {
        onStep(endValue);
        onComplete();
      }
    }
  
    raf(step);
  }
}

(function(undefined) {function ArrayCreate(r){if(1/r==-Infinity&&(r=0),r>Math.pow(2,32)-1)throw new RangeError("Invalid array length");var n=[];return n.length=r,n}function Call(t,l){var n=arguments.length>2?arguments[2]:[];if(!1===IsCallable(t))throw new TypeError(Object.prototype.toString.call(t)+"is not a function.");return t.apply(l,n)}function CreateDataProperty(e,r,t){var a={value:t,writable:!0,enumerable:!0,configurable:!0};try{return Object.defineProperty(e,r,a),!0}catch(n){return!1}}function CreateDataPropertyOrThrow(t,r,o){var e=CreateDataProperty(t,r,o);if(!e)throw new TypeError("Cannot assign value `"+Object.prototype.toString.call(o)+"` to property `"+Object.prototype.toString.call(r)+"` on object `"+Object.prototype.toString.call(t)+"`");return e}function CreateMethodProperty(e,r,t){var a={value:t,writable:!0,enumerable:!1,configurable:!0};Object.defineProperty(e,r,a)}function Get(n,t){return n[t]}function HasProperty(n,r){return r in n}function IsArray(r){return"[object Array]"===Object.prototype.toString.call(r)}function IsCallable(n){return"function"==typeof n}function ToBoolean(o){return Boolean(o)}function ToInteger(n){var i=Number(n);return isNaN(i)?0:1/i===Infinity||1/i==-Infinity||i===Infinity||i===-Infinity?i:(i<0?-1:1)*Math.floor(Math.abs(i))}function ToLength(n){var t=ToInteger(n);return t <=0?0:Math.min(t,Math.pow(2,53)-1)}function ToObject(e){if(null===e||e===undefined)throw TypeError();return Object(e)}function GetV(t,e){return ToObject(t)[e]}function GetMethod(e,n){var r=GetV(e,n);if(null===r||r===undefined)return undefined;if(!1===IsCallable(r))throw new TypeError("Method not callable: "+n);return r}function Type(e){switch(typeof e){case"undefined":return"undefined";case"boolean":return"boolean";case"number":return"number";case"string":return"string";case"symbol":return"symbol";default:return null===e?"null":"Symbol"in this&&e instanceof this.Symbol?"symbol":"object"}}function GetPrototypeFromConstructor(t,o){var r=Get(t,"prototype");return"object"!==Type(r)&&(r=o),r}function OrdinaryCreateFromConstructor(r,e){var t=arguments[2]||{},o=GetPrototypeFromConstructor(r,e),a=Object.create(o);for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&Object.defineProperty (a,n,{configurable:!0,enumerable:!1,writable:!0,value:t[n]});return a}function IsConstructor(t){return"object"===Type(t)&&("function"==typeof t&&!!t.prototype)}function Construct(r){var t=arguments.length>2?arguments[2]:r,o=arguments.length>1?arguments[1]:[];if(!IsConstructor(r))throw new TypeError("F must be a constructor.");if(!IsConstructor(t))throw new TypeError("newTarget must be a constructor.");if(t===r)return new(Function.prototype.bind.apply(r,[null].concat(o)));var n=OrdinaryCreateFromConstructor(t,Object.prototype);return Call(r,n,o)}function ArraySpeciesCreate(r,e){if(1/e==-Infinity&&(e=0),!1===IsArray(r))return ArrayCreate(e);var t=Get(r,"constructor");if("object"===Type(t)&&null ===(t="Symbol"in this&&"species"in this.Symbol?Get(t,this.Symbol.species):undefined)&&(t=undefined),t===undefined)return ArrayCreate(e);if(!IsConstructor(t))throw new TypeError("C must be a constructor");return Construct(t,[e])}function OrdinaryToPrimitive(r,t){if("string"===t)var e=["toString","valueOf"];else e=["valueOf","toString"];for(var i=0;i<e.length;++i){var n=e[i],a= Get(r,n);if(IsCallable(a)){var o=Call(a,r);if("object" !== Type(o))return o}}throw new TypeError("Cannot convert to primitive." )}function ToPrimitive(e){var t=arguments.length>1?arguments[1]:undefined;if("object"===Type(e)){if(arguments.length<2)var i="default";else t===String?i="string":t===Number&&(i="number");var r="function"==typeof this.Symbol&&"symbol"==typeof this.Symbol.toPrimitive?GetMethod(e,this.Symbol.toPrimitive):undefined;if(r!==undefined){var n=Call(r,e,[i]);if("object"!==Type(n))return n;throw new TypeError("Cannot convert exotic object to primitive.")}return "default"===i&&(i="number"),OrdinaryToPrimitive(e,i)}return e}function ToString(t){switch(Type(t)){case "symbol":throw new TypeError("Cannot convert a Symbol value to a string");case "object":return ToString(ToPrimitive(t,"string"));default:return String(t)}}if(!("fetch"in this)){!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e(t.WHATWGFetch={})}(this,function(t){"use strict";function e(t){return t&&DataView.prototype.isPrototypeOf(t)}function r(t){if("string"!=typeof t&&(t=String(t)),/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(t))throw new TypeError("Invalid character in header field name");return t.toLowerCase()}function o(t){return"string"!=typeof t&&(t=String(t)),t}function n(t){var e={next:function(){var e=t.shift();return{done:e===undefined,value:e}}};return v.iterable&&(e[Symbol.iterator]=function(){return e}),e}function i(t){this.map={},t instanceof i?t.forEach(function(t,e){this.append(e,t)},this):Array.isArray(t)?t.forEach(function(t){this.append(t[0],t[1])},this):t&&Object.getOwnPropertyNames(t).forEach(function(e){this.append(e,t[e])},this)}function s(t){if(t.bodyUsed)return Promise.reject(new TypeError("Already read"));t.bodyUsed=!0}function a(t){return new Promise(function(e,r){t.onload=function(){e(t.result)},t.onerror=function(){r(t.error)}})}function f(t){var e=new FileReader,r=a(e);return e.readAsArrayBuffer(t),r}function u(t){var e=new FileReader,r=a(e);return e.readAsText(t),r}function h(t){for(var e=new Uint8Array(t),r=new Array(e.length),o=0;o<e.length;o++)r[o]=String.fromCharCode(e[o]);return r.join("")}function d(t){if(t.slice)return t.slice(0);var e=new Uint8Array(t.byteLength);return e.set(new Uint8Array(t)),e.buffer}function c(){return this.bodyUsed=!1,this._initBody=function(t){this._bodyInit=t,t?"string"==typeof t?this._bodyText=t:v.blob&&Blob.prototype.isPrototypeOf(t)?this._bodyBlob=t:v.formData&&FormData.prototype.isPrototypeOf(t)?this._bodyFormData=t:v.searchParams&&URLSearchParams.prototype.isPrototypeOf(t)?this._bodyText=t.toString():v.arrayBuffer&&v.blob&&e(t)?(this._bodyArrayBuffer=d(t.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer])):v.arrayBuffer&&(ArrayBuffer.prototype.isPrototypeOf(t)||A(t))?this._bodyArrayBuffer=d(t):this._bodyText=t=Object.prototype.toString.call(t):this._bodyText="",this.headers.get("content-type")||("string"==typeof t?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):v.searchParams&&URLSearchParams.prototype.isPrototypeOf(t)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"))},v.blob&&(this.blob=function(){var t=s(this);if(t)return t;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){return this._bodyArrayBuffer?s(this)||Promise.resolve(this._bodyArrayBuffer):this.blob().then(f)}),this.text=function(){var t=s(this);if(t)return t;if(this._bodyBlob)return u(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(h(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},v.formData&&(this.formData=function(){return this.text().then(l)}),this.json=function(){return this.text().then(JSON.parse)},this}function y(t){var e=t.toUpperCase();return _.indexOf(e)>-1?e:t}function p(t,e){e=e||{};var r=e.body;if(t instanceof p){if(t.bodyUsed)throw new TypeError("Already read");this.url=t.url,this.credentials=t.credentials,e.headers||(this.headers=new i(t.headers)),this.method=t.method,this.mode=t.mode,this.signal=t.signal,r||null==t._bodyInit||(r=t._bodyInit,t.bodyUsed=!0)}else this.url=String(t);if(this.credentials=e.credentials||this.credentials||"same-origin",!e.headers&&this.headers||(this.headers=new i(e.headers)),this.method=y(e.method||this.method||"GET"),this.mode=e.mode||this.mode||null,this.signal=e.signal||this.signal,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&r)throw new TypeError("Body not allowed for GET or HEAD requests");this._initBody(r)}function l(t){var e=new FormData;return t.trim().split("&").forEach(function(t){if(t){var r=t.split("="),o=r.shift().replace(/\+/g," "),n=r.join("=").replace(/\+/g," ");e.append(decodeURIComponent(o),decodeURIComponent(n))}}),e}function b(t){var e=new i;return t.replace(/\r?\n[\t ]+/g," ").split(/\r?\n/).forEach(function(t){var r=t.split(":"),o=r.shift().trim();if(o){var n=r.join(":").trim();e.append(o,n)}}),e}function m(t,e){e||(e={}),this.type="default",this.status=e.status===undefined?200:e.status,this.ok=this.status>=200&&this.status<300,this.statusText="statusText"in e?e.statusText:"OK",this.headers=new i(e.headers),this.url=e.url||"",this._initBody(t)}function w(e,r){return new Promise(function(o,n){function i(){a.abort()}var s=new p(e,r);if(s.signal&&s.signal.aborted)return n(new t.DOMException("Aborted","AbortError"));var a=new XMLHttpRequest;a.onload=function(){var t={status:a.status,statusText:a.statusText,headers:b(a.getAllResponseHeaders()||"")};t.url="responseURL"in a?a.responseURL:t.headers.get("X-Request-URL");var e="response"in a?a.response:a.responseText;o(new m(e,t))},a.onerror=function(){n(new TypeError("Network request failed"))},a.ontimeout=function(){n(new TypeError("Network request failed"))},a.onabort=function(){n(new t.DOMException("Aborted","AbortError"))},a.open(s.method,s.url,!0),"include"===s.credentials?a.withCredentials=!0:"omit"===s.credentials&&(a.withCredentials=!1),"responseType"in a&&v.blob&&(a.responseType="blob"),s.headers.forEach(function(t,e){a.setRequestHeader(e,t)}),s.signal&&(s.signal.addEventListener("abort",i),a.onreadystatechange=function(){4===a.readyState&&s.signal.removeEventListener("abort",i)}),a.send("undefined"==typeof s._bodyInit?null:s._bodyInit)})}var v={searchParams:"URLSearchParams"in self,iterable:"Symbol"in self&&"iterator"in Symbol,blob:"FileReader"in self&&"Blob"in self&&function(){try{return new Blob,!0}catch(t){return!1}}(),formData:"FormData"in self,arrayBuffer:"ArrayBuffer"in self};if(v.arrayBuffer)var E=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],A=ArrayBuffer.isView||function(t){return t&&E.indexOf(Object.prototype.toString.call(t))>-1};i.prototype.append=function(t,e){t=r(t),e=o(e);var n=this.map[t];this.map[t]=n?n+", "+e:e},i.prototype["delete"]=function(t){delete this.map[r(t)]},i.prototype.get=function(t){return t=r(t),this.has(t)?this.map[t]:null},i.prototype.has=function(t){return this.map.hasOwnProperty(r(t))},i.prototype.set=function(t,e){this.map[r(t)]=o(e)},i.prototype.forEach=function(t,e){for(var r in this.map)this.map.hasOwnProperty(r)&&t.call(e,this.map[r],r,this)},i.prototype.keys=function(){var t=[];return this.forEach(function(e,r){t.push(r)}),n(t)},i.prototype.values=function(){var t=[];return this.forEach(function(e){t.push(e)}),n(t)},i.prototype.entries=function(){var t=[];return this.forEach(function(e,r){t.push([r,e])}),n(t)},v.iterable&&(i.prototype[Symbol.iterator]=i.prototype.entries);var _=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];p.prototype.clone=function(){return new p(this,{body:this._bodyInit})},c.call(p.prototype),c.call(m.prototype),m.prototype.clone=function(){return new m(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new i(this.headers),url:this.url})},m.error=function(){var t=new m(null,{status:0,statusText:""});return t.type="error",t};var x=[301,302,303,307,308];m.redirect=function(t,e){if(-1===x.indexOf(e))throw new RangeError("Invalid status code");return new m(null,{status:e,headers:{location:t}})},t.DOMException=self.DOMException;try{new t.DOMException}catch(g){t.DOMException=function(t,e){this.message=t,this.name=e;var r=Error(t);this.stack=r.stack},t.DOMException.prototype=Object.create(Error.prototype),t.DOMException.prototype.constructor=t.DOMException}w.polyfill=!0,self.fetch=w,self.Headers=i,self.Request=p,self.Response=m,t.Headers=i,t.Request=p,t.Response=m,t.fetch=w,Object.defineProperty(t,"__esModule",{value:!0})});}if (!("IntersectionObserver"in window&&"IntersectionObserverEntry"in window&&"intersectionRatio"in window.IntersectionObserverEntry.prototype
)) {!function(t,e){"use strict";function n(t){this.time=t.time,this.target=t.target,this.rootBounds=t.rootBounds,this.boundingClientRect=t.boundingClientRect,this.intersectionRect=t.intersectionRect||a();try{this.isIntersecting=!!t.intersectionRect}catch(r){}var e=this.boundingClientRect,n=e.width*e.height,o=this.intersectionRect,i=o.width*o.height;this.intersectionRatio=n?Number((i/n).toFixed(4)):this.isIntersecting?1:0}function o(t,e){var n=e||{};if("function"!=typeof t)throw new Error("callback must be a function");if(n.root&&1!=n.root.nodeType)throw new Error("root must be an Element");this._checkForIntersections=r(this._checkForIntersections.bind(this),this.THROTTLE_TIMEOUT),this._callback=t,this._observationTargets=[],this._queuedEntries=[],this._rootMarginValues=this._parseRootMargin(n.rootMargin),this.thresholds=this._initThresholds(n.threshold),this.root=n.root||null,this.rootMargin=this._rootMarginValues.map(function(t){return t.value+t.unit}).join(" ")}function i(){return t.performance&&performance.now&&performance.now()}function r(t,e){var n=null;return function(){n||(n=setTimeout(function(){t(),n=null},e))}}function s(t,e,n,o){"function"==typeof t.addEventListener?t.addEventListener(e,n,o||!1):"function"==typeof t.attachEvent&&t.attachEvent("on"+e,n)}function h(t,e,n,o){"function"==typeof t.removeEventListener?t.removeEventListener(e,n,o||!1):"function"==typeof t.detatchEvent&&t.detatchEvent("on"+e,n)}function c(t,e){var n=Math.max(t.top,e.top),o=Math.min(t.bottom,e.bottom),i=Math.max(t.left,e.left),r=Math.min(t.right,e.right),s=r-i,h=o-n;return s>=0&&h>=0&&{top:n,bottom:o,left:i,right:r,width:s,height:h}}function u(t){var e;try{e=t.getBoundingClientRect()}catch(n){}return e?(e.width&&e.height||(e={top:e.top,right:e.right,bottom:e.bottom,left:e.left,width:e.right-e.left,height:e.bottom-e.top}),e):a()}function a(){return{top:0,bottom:0,left:0,right:0,width:0,height:0}}function l(t,e){for(var n=e;n;){if(n==t)return!0;n=p(n)}return!1}function p(t){var e=t.parentNode;return e&&11==e.nodeType&&e.host?e.host:e&&e.assignedSlot?e.assignedSlot.parentNode:e}var f=[];o.prototype.THROTTLE_TIMEOUT=100,o.prototype.POLL_INTERVAL=null,o.prototype.USE_MUTATION_OBSERVER=!0,o.prototype.observe=function(t){if(!this._observationTargets.some(function(e){return e.element==t})){if(!t||1!=t.nodeType)throw new Error("target must be an Element");this._registerInstance(),this._observationTargets.push({element:t,entry:null}),this._monitorIntersections(),this._checkForIntersections()}},o.prototype.unobserve=function(t){this._observationTargets=this._observationTargets.filter(function(e){return e.element!=t}),this._observationTargets.length||(this._unmonitorIntersections(),this._unregisterInstance())},o.prototype.disconnect=function(){this._observationTargets=[],this._unmonitorIntersections(),this._unregisterInstance()},o.prototype.takeRecords=function(){var t=this._queuedEntries.slice();return this._queuedEntries=[],t},o.prototype._initThresholds=function(t){var e=t||[0];return Array.isArray(e)||(e=[e]),e.sort().filter(function(t,e,n){if("number"!=typeof t||isNaN(t)||t<0||t>1)throw new Error("threshold must be a number between 0 and 1 inclusively");return t!==n[e-1]})},o.prototype._parseRootMargin=function(t){var e=t||"0px",n=e.split(/\s+/).map(function(t){var e=/^(-?\d*\.?\d+)(px|%)$/.exec(t);if(!e)throw new Error("rootMargin must be specified in pixels or percent");return{value:parseFloat(e[1]),unit:e[2]}});return n[1]=n[1]||n[0],n[2]=n[2]||n[0],n[3]=n[3]||n[1],n},o.prototype._monitorIntersections=function(){this._monitoringIntersections||(this._monitoringIntersections=!0,this.POLL_INTERVAL?this._monitoringInterval=setInterval(this._checkForIntersections,this.POLL_INTERVAL):(s(t,"resize",this._checkForIntersections,!0),s(e,"scroll",this._checkForIntersections,!0),this.USE_MUTATION_OBSERVER&&"MutationObserver"in t&&(this._domObserver=new MutationObserver(this._checkForIntersections),this._domObserver.observe(e,{attributes:!0,childList:!0,characterData:!0,subtree:!0}))))},o.prototype._unmonitorIntersections=function(){this._monitoringIntersections&&(this._monitoringIntersections=!1,clearInterval(this._monitoringInterval),this._monitoringInterval=null,h(t,"resize",this._checkForIntersections,!0),h(e,"scroll",this._checkForIntersections,!0),this._domObserver&&(this._domObserver.disconnect(),this._domObserver=null))},o.prototype._checkForIntersections=function(){var t=this._rootIsInDom(),e=t?this._getRootRect():a();this._observationTargets.forEach(function(o){var r=o.element,s=u(r),h=this._rootContainsTarget(r),c=o.entry,a=t&&h&&this._computeTargetAndRootIntersection(r,e),l=o.entry=new n({time:i(),target:r,boundingClientRect:s,rootBounds:e,intersectionRect:a});c?t&&h?this._hasCrossedThreshold(c,l)&&this._queuedEntries.push(l):c&&c.isIntersecting&&this._queuedEntries.push(l):this._queuedEntries.push(l)},this),this._queuedEntries.length&&this._callback(this.takeRecords(),this)},o.prototype._computeTargetAndRootIntersection=function(n,o){if("none"!=t.getComputedStyle(n).display){for(var i=u(n),r=i,s=p(n),h=!1;!h;){var a=null,l=1==s.nodeType?t.getComputedStyle(s):{};if("none"==l.display)return;if(s==this.root||s==e?(h=!0,a=o):s!=e.body&&s!=e.documentElement&&"visible"!=l.overflow&&(a=u(s)),a&&!(r=c(a,r)))break;s=p(s)}return r}},o.prototype._getRootRect=function(){var t;if(this.root)t=u(this.root);else{var n=e.documentElement,o=e.body;t={top:0,left:0,right:n.clientWidth||o.clientWidth,width:n.clientWidth||o.clientWidth,bottom:n.clientHeight||o.clientHeight,height:n.clientHeight||o.clientHeight}}return this._expandRectByRootMargin(t)},o.prototype._expandRectByRootMargin=function(t){var e=this._rootMarginValues.map(function(e,n){return"px"==e.unit?e.value:e.value*(n%2?t.width:t.height)/100}),n={top:t.top-e[0],right:t.right+e[1],bottom:t.bottom+e[2],left:t.left-e[3]};return n.width=n.right-n.left,n.height=n.bottom-n.top,n},o.prototype._hasCrossedThreshold=function(t,e){var n=t&&t.isIntersecting?t.intersectionRatio||0:-1,o=e.isIntersecting?e.intersectionRatio||0:-1;if(n!==o)for(var i=0;i<this.thresholds.length;i++){var r=this.thresholds[i];if(r==n||r==o||r<n!=r<o)return!0}},o.prototype._rootIsInDom=function(){return!this.root||l(e,this.root)},o.prototype._rootContainsTarget=function(t){return l(this.root||e,t)},o.prototype._registerInstance=function(){f.indexOf(this)<0&&f.push(this)},o.prototype._unregisterInstance=function(){var t=f.indexOf(this);-1!=t&&f.splice(t,1)},t.IntersectionObserver=o,t.IntersectionObserverEntry=n}(window,document);}if (!("freeze"in Object
)) {CreateMethodProperty(Object,"freeze",function e(r){return r});}}).call('object ' === typeof window && window || 'object ' === typeof self && self || 'object ' === typeof global && global || {});

(function(){
  /**
 * Hi :-) This is a class representing a Siema.
 */
window.Siema = class Siema {
  /**
   * Create a Siema.
   * @param {Object} options - Optional settings object.
   */
  constructor(options) {
    // Merge defaults with user's settings
    this.config = Siema.mergeSettings(options);

    // Resolve selector's type
    this.selector = typeof this.config.selector === 'string' ? document.querySelector(this.config.selector) : this.config.selector;

    // update perPage number dependable of user value
    this.resolveSlidesNumber();

    // Create global references
    this.selectorWidth = this.selector.offsetWidth;
    this.innerElements = [].slice.call(this.selector.children);
    this.currentSlide = this.config.loop ?
      this.config.startIndex % this.innerElements.length :
      Math.max(0, Math.min(this.config.startIndex, this.innerElements.length - this.perPage));
    this.transformProperty = Siema.webkitOrNot();

    // Bind all event handlers for referencability
    ['resizeHandler', 'touchstartHandler', 'touchendHandler', 'touchmoveHandler', 'mousedownHandler', 'mouseupHandler', 'mouseleaveHandler', 'mousemoveHandler', 'clickHandler'].forEach(method => {
      this[method] = this[method].bind(this);
    });

    // Build markup and apply required styling to elements
    this.init();
  }


  /**
   * Overrides default settings with custom ones.
   * @param {Object} options - Optional settings object.
   * @returns {Object} - Custom Siema settings.
   */
  static mergeSettings(options) {
    const settings = {
      selector: '.siema',
      duration: 200,
      easing: 'ease-out',
      perPage: 1,
      startIndex: 0,
      draggable: true,
      multipleDrag: true,
      threshold: 20,
      loop: false,
      rtl: false,
      onInit: () => {},
      onChange: () => {},
    };

    const userSttings = options;
    for (const attrname in userSttings) {
      settings[attrname] = userSttings[attrname];
    }

    return settings;
  }


  /**
   * Determine if browser supports unprefixed transform property.
   * Google Chrome since version 26 supports prefix-less transform
   * @returns {string} - Transform property supported by client.
   */
  static webkitOrNot() {
    const style = document.documentElement.style;
    if (typeof style.transform === 'string') {
      return 'transform';
    }
    return 'WebkitTransform';
  }

  /**
   * Attaches listeners to required events.
   */
  attachEvents() {
    // Resize element on window resize
    window.addEventListener('resize', this.resizeHandler);

    // If element is draggable / swipable, add event handlers
    if (this.config.draggable) {
      // Keep track pointer hold and dragging distance
      this.pointerDown = false;
      this.drag = {
        startX: 0,
        endX: 0,
        startY: 0,
        letItGo: null,
        preventClick: false,
      };

      // Touch events
      this.selector.addEventListener('touchstart', this.touchstartHandler, supportsPassive ? { passive: true } : false);
      this.selector.addEventListener('touchend', this.touchendHandler, supportsPassive ? { passive: true } : false);
      this.selector.addEventListener('touchmove', this.touchmoveHandler);

      // Mouse events
      this.selector.addEventListener('mousedown', this.mousedownHandler, supportsPassive ? { passive: true } : false);
      this.selector.addEventListener('mouseup', this.mouseupHandler, supportsPassive ? { passive: true } : false);
      this.selector.addEventListener('mouseleave', this.mouseleaveHandler, supportsPassive ? { passive: true } : false);
      this.selector.addEventListener('mousemove', this.mousemoveHandler);

      // Click
      this.selector.addEventListener('click', this.clickHandler);
    }
  }


  /**
   * Detaches listeners from required events.
   */
  detachEvents() {
    window.removeEventListener('resize', this.resizeHandler);
    this.selector.removeEventListener('touchstart', this.touchstartHandler);
    this.selector.removeEventListener('touchend', this.touchendHandler);
    this.selector.removeEventListener('touchmove', this.touchmoveHandler);
    this.selector.removeEventListener('mousedown', this.mousedownHandler);
    this.selector.removeEventListener('mouseup', this.mouseupHandler);
    this.selector.removeEventListener('mouseleave', this.mouseleaveHandler);
    this.selector.removeEventListener('mousemove', this.mousemoveHandler);
    this.selector.removeEventListener('click', this.clickHandler);
  }


  /**
   * Builds the markup and attaches listeners to required events.
   */
  init() {
    this.attachEvents();

    // hide everything out of selector's boundaries
    this.selector.style.overflow = 'hidden';

    // rtl or ltr
    this.selector.style.direction = this.config.rtl ? 'rtl' : 'ltr';

    // build a frame and slide to a currentSlide
    this.buildSliderFrame();

    this.config.onInit.call(this);
  }


  /**
   * Build a sliderFrame and slide to a current item.
   */
  buildSliderFrame() {
    const widthItem = this.selectorWidth / this.perPage;
    const itemsToBuild = this.config.loop ? this.innerElements.length + (2 * this.perPage) : this.innerElements.length;

    // Create frame and apply styling
    this.sliderFrame = document.createElement('div');
    this.sliderFrame.style.width = `${widthItem * itemsToBuild}px`;
    this.enableTransition();

    if (this.config.draggable) {
      this.selector.style.cursor = '-webkit-grab';
    }

    // Create a document fragment to put slides into it
    const docFragment = document.createDocumentFragment();

    // Loop through the slides, add styling and add them to document fragment
    if (this.config.loop) {
      for (let i = this.innerElements.length - this.perPage; i < this.innerElements.length; i++) {
        const element = this.buildSliderFrameItem(this.innerElements[i].cloneNode(true));
        docFragment.appendChild(element);
      }
    }
    for (let i = 0; i < this.innerElements.length; i++) {
      const element = this.buildSliderFrameItem(this.innerElements[i]);
      docFragment.appendChild(element);
    }
    if (this.config.loop) {
      for (let i = 0; i < this.perPage; i++) {
        const element = this.buildSliderFrameItem(this.innerElements[i].cloneNode(true));
        docFragment.appendChild(element);
      }
    }

    // Add fragment to the frame
    this.sliderFrame.appendChild(docFragment);

    // Clear selector (just in case something is there) and insert a frame
    this.selector.innerHTML = '';
    this.selector.appendChild(this.sliderFrame);

    // Add prev/next and pagination
    const prev = document.createElement('div');
    prev.classList.add('prev');
    prev.addEventListener('click', (e) => {
      this.goTo(this.currentSlide - 1);
    });

    const next = document.createElement('div');
    next.classList.add('next');
    next.addEventListener('click', (e) => {
      this.goTo(this.currentSlide + 1);
    });

    const pagination = document.createElement('div');
    pagination.classList.add('pagination');
    for(let i = 0; i < itemsToBuild; i++) {
      const bullet = document.createElement('span');
      if (this.currentSlide === i)
          bullet.classList.add('active');
      pagination.appendChild(bullet);
    }

    this.config.onChange = (e) => {
      const bullets = pagination.querySelectorAll('span');
      for(let i = 0; i < bullets.length; i++) {
          if (this.currentSlide === i)
              bullets[i].classList.add('active');
          else
              bullets[i].classList.remove('active');
      }
      this.updateSelectorHeight();
    }

    this.selector.appendChild(prev);
    this.selector.appendChild(next);
    this.selector.appendChild(pagination);

    // Go to currently active slide after initial build
    this.slideToCurrent();
    this.updateSelectorHeight();
  }

  updateSelectorHeight() {
    const slideIndex = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide;
    const currentSlide = this.sliderFrame.children[slideIndex];
    if (currentSlide) {
      this.selector.style.height = `${currentSlide.offsetHeight}px`;
    }
  }

  buildSliderFrameItem(elm) {
    const elementContainer = document.createElement('div');
    elementContainer.style.cssFloat = this.config.rtl ? 'right' : 'left';
    elementContainer.style.float = this.config.rtl ? 'right' : 'left';
    elementContainer.style.width = `${this.config.loop ? 100 / (this.innerElements.length + (this.perPage * 2)) : 100 / (this.innerElements.length)}%`;
    elementContainer.appendChild(elm);
    return elementContainer;
  }


  /**
   * Determinates slides number accordingly to clients viewport.
   */
  resolveSlidesNumber() {
    if (typeof this.config.perPage === 'number') {
      this.perPage = this.config.perPage;
    }
    else if (typeof this.config.perPage === 'object') {
      this.perPage = 1;
      for (const viewport in this.config.perPage) {
        if (window.innerWidth >= viewport) {
          this.perPage = this.config.perPage[viewport];
        }
      }
    }
  }


  /**
   * Go to previous slide.
   * @param {number} [howManySlides=1] - How many items to slide backward.
   * @param {function} callback - Optional callback function.
   */
  prev(howManySlides = 1, callback) {
    // early return when there is nothing to slide
    if (this.innerElements.length <= this.perPage) {
      return;
    }

    const beforeChange = this.currentSlide;

    if (this.config.loop) {
      const isNewIndexClone = this.currentSlide - howManySlides < 0;
      if (isNewIndexClone) {
        this.disableTransition();

        const mirrorSlideIndex = this.currentSlide + this.innerElements.length;
        const mirrorSlideIndexOffset = this.perPage;
        const moveTo = mirrorSlideIndex + mirrorSlideIndexOffset;
        const offset = (this.config.rtl ? 1 : -1) * moveTo * (this.selectorWidth / this.perPage);
        const dragDistance = this.config.draggable ? this.drag.endX - this.drag.startX : 0;

        this.sliderFrame.style[this.transformProperty] = `translate3d(${offset + dragDistance}px, 0, 0)`;
        this.currentSlide = mirrorSlideIndex - howManySlides;
      }
      else {
        this.currentSlide = this.currentSlide - howManySlides;
      }
    }
    else {
      this.currentSlide = Math.max(this.currentSlide - howManySlides, 0);
    }

    if (beforeChange !== this.currentSlide) {
      this.slideToCurrent(this.config.loop);
      this.config.onChange.call(this);
      if (callback) {
        callback.call(this);
      }
    }
  }


  /**
   * Go to next slide.
   * @param {number} [howManySlides=1] - How many items to slide forward.
   * @param {function} callback - Optional callback function.
   */
  next(howManySlides = 1, callback) {
    // early return when there is nothing to slide
    if (this.innerElements.length <= this.perPage) {
      return;
    }

    const beforeChange = this.currentSlide;

    if (this.config.loop) {
      const isNewIndexClone = this.currentSlide + howManySlides > this.innerElements.length - this.perPage;
      if (isNewIndexClone) {
        this.disableTransition();

        const mirrorSlideIndex = this.currentSlide - this.innerElements.length;
        const mirrorSlideIndexOffset = this.perPage;
        const moveTo = mirrorSlideIndex + mirrorSlideIndexOffset;
        const offset = (this.config.rtl ? 1 : -1) * moveTo * (this.selectorWidth / this.perPage);
        const dragDistance = this.config.draggable ? this.drag.endX - this.drag.startX : 0;

        this.sliderFrame.style[this.transformProperty] = `translate3d(${offset + dragDistance}px, 0, 0)`;
        this.currentSlide = mirrorSlideIndex + howManySlides;
      }
      else {
        this.currentSlide = this.currentSlide + howManySlides;
      }
    }
    else {
      this.currentSlide = Math.min(this.currentSlide + howManySlides, this.innerElements.length - this.perPage);
    }
    if (beforeChange !== this.currentSlide) {
      this.slideToCurrent(this.config.loop);
      this.config.onChange.call(this);
      if (callback) {
        callback.call(this);
      }
    }
  }


  /**
   * Disable transition on sliderFrame.
   */
  disableTransition() {
    this.sliderFrame.style.webkitTransition = `all 0ms ${this.config.easing}`;
    this.sliderFrame.style.transition = `all 0ms ${this.config.easing}`;
  }


  /**
   * Enable transition on sliderFrame.
   */
  enableTransition() {
    this.sliderFrame.style.webkitTransition = `all ${this.config.duration}ms ${this.config.easing}`;
    this.sliderFrame.style.transition = `all ${this.config.duration}ms ${this.config.easing}`;
  }


  /**
   * Go to slide with particular index
   * @param {number} index - Item index to slide to.
   * @param {function} callback - Optional callback function.
   */
  goTo(index, callback) {
    if (this.innerElements.length <= this.perPage) {
      return;
    }
    if (index < 0) {
      return;
    }
    if (index >= this.innerElements.length) {
      return;
    }
    const beforeChange = this.currentSlide;
    this.currentSlide = this.config.loop ?
      index % this.innerElements.length :
      Math.min(Math.max(index, 0), this.innerElements.length - this.perPage);
    if (beforeChange !== this.currentSlide) {
      this.slideToCurrent();
      this.config.onChange.call(this);
      if (callback) {
        callback.call(this);
      }
    }
  }


  /**
   * Moves sliders frame to position of currently active slide
   */
  slideToCurrent(enableTransition) {
    const currentSlide = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide;
    const offset = (this.config.rtl ? 1 : -1) * currentSlide * (this.selectorWidth / this.perPage);

    if (enableTransition) {
      // This one is tricky, I know but this is a perfect explanation:
      // https://youtu.be/cCOL7MC4Pl0
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.enableTransition();
          this.sliderFrame.style[this.transformProperty] = `translate3d(${offset}px, 0, 0)`;
        });
      });
    }
    else {
      this.sliderFrame.style[this.transformProperty] = `translate3d(${offset}px, 0, 0)`;
    }
  }


  /**
   * Recalculate drag /swipe event and reposition the frame of a slider
   */
  updateAfterDrag() {
    const movement = (this.config.rtl ? -1 : 1) * (this.drag.endX - this.drag.startX);
    const movementDistance = Math.abs(movement);
    const howManySliderToSlide = this.config.multipleDrag ? Math.ceil(movementDistance / (this.selectorWidth / this.perPage)) : 1;

    const slideToNegativeClone = movement > 0 && this.currentSlide - howManySliderToSlide < 0;
    const slideToPositiveClone = movement < 0 && this.currentSlide + howManySliderToSlide > this.innerElements.length - this.perPage;

    if (movement > 0 && movementDistance > this.config.threshold && this.innerElements.length > this.perPage) {
      this.prev(howManySliderToSlide);
      this.selector.classList.add('dragged');
    }
    else if (movement < 0 && movementDistance > this.config.threshold && this.innerElements.length > this.perPage) {
      this.next(howManySliderToSlide);
      this.selector.classList.add('dragged');
    }
    this.slideToCurrent(slideToNegativeClone || slideToPositiveClone);
  }


  /**
   * When window resizes, resize slider components as well
   */
  resizeHandler() {
    // update perPage number dependable of user value
    this.resolveSlidesNumber();

    // relcalculate currentSlide
    // prevent hiding items when browser width increases
    if (this.currentSlide + this.perPage > this.innerElements.length) {
      this.currentSlide = this.innerElements.length <= this.perPage ? 0 : this.innerElements.length - this.perPage;
    }

    this.selectorWidth = this.selector.offsetWidth;

    this.buildSliderFrame();
  }


  /**
   * Clear drag after touchend and mouseup event
   */
  clearDrag() {
    this.drag = {
      startX: 0,
      endX: 0,
      startY: 0,
      letItGo: null,
      preventClick: this.drag.preventClick
    };
  }


  /**
   * touchstart event handler
   */
  touchstartHandler(e) {
    // Prevent dragging / swiping on inputs, selects and textareas
    const ignoreSiema = ['TEXTAREA', 'OPTION', 'INPUT', 'SELECT'].indexOf(e.target.nodeName) !== -1;
    if (ignoreSiema) {
      return;
    }

    e.stopPropagation();
    this.pointerDown = true;
    this.drag.startX = e.touches[0].pageX;
    this.drag.startY = e.touches[0].pageY;
  }


  /**
   * touchend event handler
   */
  touchendHandler(e) {
    e.stopPropagation();
    this.pointerDown = false;
    this.enableTransition();
    if (this.drag.endX) {
      this.updateAfterDrag();
    }
    this.clearDrag();
  }


  /**
   * touchmove event handler
   */
  touchmoveHandler(e) {
    e.stopPropagation();

    if (this.drag.letItGo === null) {
      this.drag.letItGo = Math.abs(this.drag.startY - e.touches[0].pageY) < Math.abs(this.drag.startX - e.touches[0].pageX);
    }

    if (this.pointerDown && this.drag.letItGo) {
      e.preventDefault();
      this.drag.endX = e.touches[0].pageX;
      this.sliderFrame.style.webkitTransition = `all 0ms ${this.config.easing}`;
      this.sliderFrame.style.transition = `all 0ms ${this.config.easing}`;

      const currentSlide = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide;
      const currentOffset = currentSlide * (this.selectorWidth / this.perPage);
      const dragOffset = (this.drag.endX - this.drag.startX);
      const offset = this.config.rtl ? currentOffset + dragOffset : currentOffset - dragOffset;
      this.sliderFrame.style[this.transformProperty] = `translate3d(${(this.config.rtl ? 1 : -1) * offset}px, 0, 0)`;
    }
  }


  /**
   * mousedown event handler
   */
  mousedownHandler(e) {
    // Prevent dragging / swiping on inputs, selects and textareas
    const ignoreSiema = ['TEXTAREA', 'OPTION', 'INPUT', 'SELECT'].indexOf(e.target.nodeName) !== -1;
    if (ignoreSiema) {
      return;
    }

    e.stopPropagation();
    this.pointerDown = true;
    this.drag.startX = e.pageX;
  }


  /**
   * mouseup event handler
   */
  mouseupHandler(e) {
    e.stopPropagation();
    this.pointerDown = false;
    this.selector.style.cursor = '-webkit-grab';
    this.enableTransition();
    if (this.drag.endX) {
      this.updateAfterDrag();
    }
    this.clearDrag();
  }


  /**
   * mousemove event handler
   */
  mousemoveHandler(e) {
    e.preventDefault();
    if (this.pointerDown) {
      // if dragged element is a link
      // mark preventClick prop as a true
      // to detemine about browser redirection later on
      if (e.target.nodeName === 'A') {
        this.drag.preventClick = true;
      }

      this.drag.endX = e.pageX;
      this.selector.style.cursor = '-webkit-grabbing';
      this.sliderFrame.style.webkitTransition = `all 0ms ${this.config.easing}`;
      this.sliderFrame.style.transition = `all 0ms ${this.config.easing}`;

      const currentSlide = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide;
      const currentOffset = currentSlide * (this.selectorWidth / this.perPage);
      const dragOffset = (this.drag.endX - this.drag.startX);
      const offset = this.config.rtl ? currentOffset + dragOffset : currentOffset - dragOffset;
      this.sliderFrame.style[this.transformProperty] = `translate3d(${(this.config.rtl ? 1 : -1) * offset}px, 0, 0)`;
    }
  }


  /**
   * mouseleave event handler
   */
  mouseleaveHandler(e) {
    if (this.pointerDown) {
      this.pointerDown = false;
      this.selector.style.cursor = '-webkit-grab';
      this.drag.endX = e.pageX;
      this.drag.preventClick = false;
      this.enableTransition();
      this.updateAfterDrag();
      this.clearDrag();
    }
  }


  /**
   * click event handler
   */
  clickHandler(e) {
    // if the dragged element is a link
    // prevent browsers from folowing the link
    if (this.drag.preventClick) {
      e.preventDefault();
    }
    this.drag.preventClick = false;
  }


  /**
   * Remove item from carousel.
   * @param {number} index - Item index to remove.
   * @param {function} callback - Optional callback to call after remove.
   */
  remove(index, callback) {
    // Shift sliderFrame back by one item when:
    // 1. Item with lower index than currenSlide is removed.
    // 2. Last item is removed.
    const lowerIndex = index < this.currentSlide;
    const lastItem = this.currentSlide + this.perPage - 1 === index;

    if (lowerIndex || lastItem) {
      this.currentSlide--;
    }

    this.innerElements.splice(index, 1);

    // build a frame and slide to a currentSlide
    this.buildSliderFrame();

    if (callback) {
      callback.call(this);
    }
  }


  /**
   * Insert item to carousel at particular index.
   * @param {HTMLElement} item - Item to insert.
   * @param {number} index - Index of new new item insertion.
   * @param {function} callback - Optional callback to call after insert.
   */
  insert(item, index, callback) {
    // Avoid shifting content
    const shouldItShift = index <= this.currentSlide > 0 && this.innerElements.length;
    this.currentSlide = shouldItShift ? this.currentSlide + 1 : this.currentSlide;

    this.innerElements.splice(index, 0, item);

    // build a frame and slide to a currentSlide
    this.buildSliderFrame();

    if (callback) {
      callback.call(this);
    }
  }


  /**
   * Prepernd item to carousel.
   * @param {HTMLElement} item - Item to prepend.
   * @param {function} callback - Optional callback to call after prepend.
   */
  prepend(item, callback) {
    this.insert(item, 0);
    if (callback) {
      callback.call(this);
    }
  }


  /**
   * Append item to carousel.
   * @param {HTMLElement} item - Item to append.
   * @param {function} callback - Optional callback to call after append.
   */
  append(item, callback) {
    this.insert(item, this.innerElements.length + 1);
    if (callback) {
      callback.call(this);
    }
  }


  /**
   * Removes listeners and optionally restores to initial markup
   * @param {boolean} restoreMarkup - Determinants about restoring an initial markup.
   * @param {function} callback - Optional callback function.
   */
  destroy(restoreMarkup = false, callback) {
    this.detachEvents();

    this.selector.style.cursor = 'auto';

    if (restoreMarkup) {
      const slides = document.createDocumentFragment();
      for (let i = 0; i < this.innerElements.length; i++) {
        slides.appendChild(this.innerElements[i]);
      }
      this.selector.innerHTML = '';
      this.selector.appendChild(slides);
      this.selector.removeAttribute('style');
    }

    if (callback) {
      callback.call(this);
    }
  }
}
})();

function initChat() {
  window.BriefWidgetId = 'a789a8be-be39-4136-8f7c-f071ff5b699e';
  (function() {
      var w = window; var d = document;
  
      function isIos() {
          var ua = window.navigator.userAgent;
          var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
          var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
          var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
          return ipad || iphone || ipod;
      }
  
      function l() {
          var isStartpage = document.body.classList.contains('blog');
          if (isStartpage)
          {
            if (isIos()) 
              return;
          }
  
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.letsbrief.com/widget/widget.js';
          d.head.appendChild(s);
      }

      l();
  })();
}

function scheduleChatInit() {
  var initialized = false;
  var events = ['click', 'keydown', 'scroll'];
  var fallback = window.setTimeout(loadChat, 8000);

  function scheduleLoadChat(event) {
    if (event.type === 'click' && event.target.closest && event.target.closest('header nav a')) {
      cancelChatInit();
      return;
    }

    // Let the current interaction (especially a touch-generated link click)
    // finish before the widget changes the DOM.
    window.setTimeout(loadChat, 0);
  }

  function cancelChatInit() {
    initialized = true;
    stopListening();
  }

  function stopListening() {
    window.clearTimeout(fallback);
    for (var i = 0; i < events.length; i++)
      window.removeEventListener(events[i], scheduleLoadChat);
  }

  function loadChat() {
    if (initialized)
      return;

    initialized = true;
    stopListening();
    initChat();
  }

  for (var i = 0; i < events.length; i++)
    window.addEventListener(events[i], scheduleLoadChat, { passive: true, once: true });
}

start();
scheduleChatInit();
